import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { body2, body2Bold, colors, spacing } from 'ui/theme';
import { Link } from 'ui/links';

export const StyledTitle = styled.div`
  ${body2Bold};
`;

export const StyledHeader = styled.span`
  ${body2};
  display: block;
  color: ${colors.secondaryText};
  margin-bottom: ${spacing.half};
`;

export const StyledSection = styled.section`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledLink = styled(Link)`
  color: inherit;
  text-decoration-color: inherit;
`;

export const StyledBanner = styled(InfoBanner)`
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
